{
    "title":"Verification code Validation",
    "otpValidationForm": {
        "otp": "Verification Code",
        "newPassword": "Create New Password",
        "confirmPassword": "Confirm New Password"
    },
    "validatingMsgs":{
        "otp":"Please enter valid Verification code",
        "newPswd":"Password is required",
        "numberOnly":"Number Only",
        "confirmNewPswd":"Confirm Password is required",
        "mustMatch":"Password Must be match",
        "mustValid":"Password must be at least 6 characters"
    },
    "placeHolders":{
        "otp": "Enter Verification Code",
        "newPswd":"Enter New Password",
        "confirmPswd":"Confirm New Password"
    },
    "backBtn":{
        "label": "Back"
    },
    "submitBtn":{
        "label": "Submit"
    },
    "resendBtn":{
        "label":"Resend?"
    }
}